import { render, staticRenderFns } from "./NavList.vue?vue&type=template&id=b38fca42&"
import script from "./NavList.vue?vue&type=script&lang=ts&"
export * from "./NavList.vue?vue&type=script&lang=ts&"
import style0 from "./NavList.vue?vue&type=style&index=0&id=b38fca42&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports